module.exports = __webpack_public_path__ + "static/media/colors-colours-health-medicine.9998c9b8.jpg";